import {
  AUTH_LOGIN_REQUEST,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGIN_FAILURE,
  AUTH_LOGOUT_REQUEST,
  AUTH_REGISTER_SUCCESS,
  AUTH_REGISTER_REQUEST,
  AUTH_REGISTER_FAILURE
} from "../constants/authConstant";

const accessToken = localStorage.getItem("accessToken")
  ? localStorage.getItem("accessToken")
  : null;

const userInitialState = {
  user: null,
  error: null,
  loading: false,
  accessToken
};

export const authLoginReducer = (state = userInitialState, action) => {
  switch (action.type) {
    case AUTH_LOGIN_REQUEST:
      return { ...state, loading: true, error: null };
    case AUTH_LOGIN_SUCCESS:
      return {
        loading: false,
        user: action.payload.user,
        accessToken: action.payload.accessToken,
        error: null
      };
    case AUTH_LOGIN_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case AUTH_LOGOUT_REQUEST:
      return { user: null, error: null, loading: false };
    default:
      return state;
  }
};

const newUserIntialState = {
  user: null,
  error: null,
  loading: false
};

export const authRegisterReducer = (state = newUserIntialState, action) => {
  switch (action.type) {
    case AUTH_REGISTER_REQUEST:
      return { user: null, error: null, loading: true };
    case AUTH_REGISTER_SUCCESS:
      return {
        error: null,
        user: action.payload,
        loading: false
      };
    case AUTH_REGISTER_FAILURE:
      return {
        user: null,
        error: action.payload,
        loading: false
      };

    default:
      return state;
  }
};
